import React from 'react';
import { Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const activityLogs = [
  { id: 1, user: 'John Doe', action: 'Logged in', timestamp: '2023-05-15 10:30:00' },
  { id: 2, user: 'Jane Smith', action: 'Updated user role', timestamp: '2023-05-15 11:15:00' },
  { id: 3, user: 'Bob Johnson', action: 'Invited new user', timestamp: '2023-05-15 12:00:00' },
  { id: 4, user: 'Alice Brown', action: 'Modified bot configuration', timestamp: '2023-05-15 13:45:00' },
  { id: 5, user: 'Charlie Davis', action: 'Viewed analytics', timestamp: '2023-05-15 14:30:00' },
];

const ActivityLogs = () => {
  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>Activity Logs</Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>User</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>Timestamp</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {activityLogs.map((log) => (
              <TableRow key={log.id}>
                <TableCell>{log.user}</TableCell>
                <TableCell>{log.action}</TableCell>
                <TableCell>{log.timestamp}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ActivityLogs;
